/**
 * 页面的Mixin , 提取公共部分
 * create by sevencai@20180829
 * contact sevencai@tencent.com
 */
import * as Raven from 'raven-js'
import Product from '@/components/Base/Product.vue'
import * as handler from '@/api/handler'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {}
  },

  components: {
    Product
  },

  methods: {
    /**
     * 上报错误到 raven.js
     * @param err
     * @param msg
     */
    /* eslint-disable no-underscore-dangle  */
    reportError(err: Error, msg: string) {
      Raven.captureBreadcrumb({
        message: msg,
        category: 'error',
        data: {
          data: this.$data
        },
        time: new Date(),
        wxinfo: {
          info1: window._wxinfo1,
          info2: window._wxinfo2
        }
      } as any)

      Raven.captureException(err)
    },

    /**
     * 判断是否在活动时间范围内
     * @param store
     * @returns {*}
     */
    checkInActivity(store: Timed): boolean {
      return handler.checkInActivityTime(store)
    }
  }
})
